import React, { useState, useEffect, useContext, useRef } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  MenuItem,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Avatar,
  Divider,
  Switch,
  FormControlLabel,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { ContextSession } from "../../services/ContextSession";
import { useNavigate } from "react-router-dom";

const DEPARTAMENTO_CHOICES = [
  { value: "Call Center", label: "Call Center" },
  { value: "Comunicaciones", label: "Comunicaciones" },
  {
    value: "Departamento de Cartera y Cobro",
    label: "Departamento de Cartera y Cobro",
  },
  {
    value: "Departamento de Control de Ingresos",
    label: "Departamento de Control de Ingresos",
  },
  { value: "Departamento Prestamos", label: "Departamento Prestamos" },
  {
    value: "Departamento de Relaciones Institucionales",
    label: "Departamento de Relaciones Institucionales",
  },
  {
    value: "División de Actuaría y Estadísticas",
    label: "División de Actuaría y Estadísticas",
  },
  { value: "División de Beneficios", label: "División de Beneficios" },
  { value: "División de Prestamos", label: "División de Prestamos" },
  { value: "División de Negocios", label: "División de Negocios" },
  {
    value: "División de Servicios Legales",
    label: "División de Servicios Legales",
  },
  {
    value: "División de Servicios Legales S.P.S",
    label: "División de Servicios Legales S.P.S",
  },
  { value: "Pensiones Especiales", label: "Pensiones Especiales" },
  { value: "Planilla de Jubilados", label: "Planilla de Jubilados" },
  { value: "Secretaría General", label: "Secretaría General" },
  {
    value: "Unidad de Auditoría Interna",
    label: "Unidad de Auditoría Interna",
  },
  { value: "Unidad de Operaciones", label: "Unidad de Operaciones" },
  {
    value: "Unidad de Riesgos y Cumplimiento",
    label: "Unidad de Riesgos y Cumplimiento",
  },
  {
    value: "Unidad de Servicios Sociales",
    label: "Unidad de Servicios Sociales",
  },
  {
    value: "Unidad Técnica de Desarrollo Institucional",
    label: "Unidad Técnica de Desarrollo Institucional",
  },
  {
    value: "Unidad Técnica de Informática",
    label: "Unidad Técnica de Informática",
  },
  { value: "Unidad Servicios Generales", label: "Unidad Servicios Generales" },
];

const SUPERVISOR_ALLOWED_DEPARTMENTS = [
  "Departamento de Control de Ingresos",
  "Departamento Prestamos",
];

const normalizeDepartmentValue = (value) => String(value || "").trim();

const isSupervisorDepartment = (department) =>
  SUPERVISOR_ALLOWED_DEPARTMENTS.includes(
    normalizeDepartmentValue(department),
  );

const CrearUsuarios360 = () => {
  const sessi = useContext(ContextSession);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    usuario: "",
    correo: "",
    nombres: "",
    apellidos: "",
    contrasena: "",
    departamento: "",
    oficina: "",
    foto: null,
    supervisor: false,
    dni: "",
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [oficinas, setOficinas] = useState([]);

  const [cameraOpen, setCameraOpen] = useState(false);
  const [stream, setStream] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    fetchOficinas();
  }, []);

  const fetchOficinas = async () => {
    try {
      const response = await fetch(
        "https://bei360.injupemp.gob.hn:8444/api/Oficinas/Consultar/",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        },
      );

      if (response.status === 401) {
        const result = await response.json();
        if (result.code === "token_not_valid") {
          sessi.clearSession();
          navigate("/");
          return;
        }
      }

      const data = await response.json();
      setOficinas(data);
    } catch (error) {
      console.error("Error fetching oficinas:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "dni"
          ? String(value || "").replace(/\D/g, "").slice(0, 13)
          : value,
    }));
  };

  const handleSupervisorChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      supervisor: event.target.checked,
    }));
  };

  const openCamera = async () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });

      setStream(mediaStream);
      setCameraOpen(true);

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
        }
      }, 100);
    } catch (error) {
      console.error("Error al abrir la cámara:", error);
      alert("No se pudo acceder a la cámara.");
    }
  };

  const takePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      const file = new File([blob], "foto_usuario.jpg", {
        type: "image/jpeg",
      });

      setFormData((prev) => ({ ...prev, foto: file }));
      setPhotoPreview(URL.createObjectURL(blob));
    }, "image/jpeg");

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }

    setStream(null);
    setCameraOpen(false);

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanedDni = String(formData.dni || "").replace(/\D/g, "");

    if (formData.supervisor && !isSupervisorDepartment(formData.departamento)) {
      setErrorMessage(
        "Si el usuario es supervisor, el departamento debe ser Departamento de Control de Ingresos o Departamento Prestamos.",
      );
      setSuccess(false);
      setDialogOpen(true);
      return;
    }

    if (formData.supervisor && cleanedDni.length !== 13) {
      setErrorMessage(
        "El DNI del usuario es obligatorio y debe tener 13 dígitos cuando es supervisor.",
      );
      setSuccess(false);
      setDialogOpen(true);
      return;
    }

    const data = new FormData();
    data.append("email", formData.correo);
    data.append("username", formData.usuario);
    data.append("first_name", formData.nombres);
    data.append("last_name", formData.apellidos);

    if (formData.contrasena) {
      data.append("password", formData.contrasena);
    }

    if (formData.foto) {
      data.append("photo", formData.foto);
    }

    data.append("departamento", formData.departamento);
    data.append("oficina", formData.oficina);
    data.append("supervisor", formData.supervisor ? 1 : 0);
    data.append("dni", cleanedDni);

    try {
      const response = await fetch(
        "https://bei360.injupemp.gob.hn:8444/api/auth/register",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
          body: data,
        },
      );

      const result = await response.json();

      if (response.ok) {
        setDialogMessage("Usuario creado exitosamente.");
        setSuccess(true);
      } else {
        setErrorMessage(result.username?.[0] || "Error desconocido.");
        setSuccess(false);

        if (response.status === 401 && result.code === "token_not_valid") {
          sessi.clearSession();
          navigate("/");
          return;
        }
      }
    } catch (error) {
      setErrorMessage("Error en la conexión. Por favor intenta nuevamente.");
      setSuccess(false);
    } finally {
      setDialogOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    if (success) {
      navigate("/UTI/ListaUsuariosi360");
    } else {
      setErrorMessage("");
    }
  };

  const invalidSupervisorDepartment =
    formData.supervisor && !isSupervisorDepartment(formData.departamento);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 4,
        bgcolor: "#f4f6f8",
        minHeight: "100vh",
        py: 4,
      }}
    >
      <Card
        elevation={6}
        sx={{
          maxWidth: 750,
          width: "100%",
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Avatar
              sx={{
                mx: "auto",
                width: 70,
                height: 70,
                bgcolor: "#6b95c0",
                mb: 1,
              }}
            >
              <PhotoCamera fontSize="large" />
            </Avatar>

            <Typography variant="h5" fontWeight="bold">
              Crear Usuario INJUPEMP 360
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Complete la información y tome la fotografía del usuario
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <form onSubmit={handleSubmit}>
            <TextField
              label="Nombre de Usuario"
              name="usuario"
              fullWidth
              margin="normal"
              value={formData.usuario}
              onChange={handleChange}
              required
              inputProps={{ style: { textTransform: "uppercase" } }}
            />

            <TextField
              label="Correo"
              name="correo"
              fullWidth
              margin="normal"
              value={formData.correo}
              onChange={handleChange}
              required
              inputProps={{ style: { textTransform: "uppercase" } }}
            />

            <TextField
              label="Nombres"
              name="nombres"
              fullWidth
              margin="normal"
              value={formData.nombres}
              onChange={handleChange}
              required
              inputProps={{ style: { textTransform: "uppercase" } }}
            />

            <TextField
              label="Apellidos"
              name="apellidos"
              fullWidth
              margin="normal"
              value={formData.apellidos}
              onChange={handleChange}
              required
              inputProps={{ style: { textTransform: "uppercase" } }}
            />

            <TextField
              label="Contraseña"
              name="contrasena"
              type="password"
              fullWidth
              margin="normal"
              value={formData.contrasena}
              onChange={handleChange}
            />

            <TextField
              select
              label="Departamento"
              name="departamento"
              fullWidth
              margin="normal"
              value={formData.departamento}
              onChange={handleChange}
              required
              error={invalidSupervisorDepartment}
              helperText={
                formData.supervisor
                  ? "Para supervisor solo se permiten Departamento de Control de Ingresos y Departamento Prestamos."
                  : ""
              }
            >
              {DEPARTAMENTO_CHOICES.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  disabled={
                    formData.supervisor &&
                    !SUPERVISOR_ALLOWED_DEPARTMENTS.includes(option.value)
                  }
                >
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Oficina"
              name="oficina"
              fullWidth
              margin="normal"
              value={formData.oficina}
              onChange={handleChange}
              required
            >
              <MenuItem value="">Seleccionar Oficina</MenuItem>
              {oficinas.map((oficina) => (
                <MenuItem key={oficina.OficinaId} value={oficina.OficinaId}>
                  {oficina.nombre}
                </MenuItem>
              ))}
            </TextField>

            <Box sx={{ mt: 1 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.supervisor}
                    onChange={handleSupervisorChange}
                    color="primary"
                  />
                }
                label="Supervisor de usuarios"
              />
            </Box>

            {formData.supervisor && (
              <TextField
                label="DNI de usuario"
                name="dni"
                fullWidth
                margin="normal"
                value={formData.dni}
                onChange={handleChange}
                required
                inputProps={{ maxLength: 13, inputMode: "numeric" }}
                helperText="Ingrese el DNI de 13 dígitos."
              />
            )}

            {formData.supervisor && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mt: 1, display: "block" }}
              >
                Al activar supervisor, el DNI del usuario se utiliza para los
                flujos que consultan supervisores.
              </Typography>
            )}

            <Button
              type="button"
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                py: 1.5,
                fontSize: "1rem",
                fontWeight: "bold",
                background: "linear-gradient(45deg, #6b95c0, #5f9be0)",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                "&:hover": {
                  background: "linear-gradient(45deg, #6b95c0, #70a0e7)",
                },
              }}
              onClick={openCamera}
              startIcon={<PhotoCamera />}
            >
              TOMAR FOTO
            </Button>

            {cameraOpen && (
              <Box sx={{ mt: 2, textAlign: "center" }}>
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  style={{
                    width: "100%",
                    maxHeight: 300,
                    borderRadius: 12,
                    border: "2px solid #6b95c0",
                  }}
                />
                <canvas ref={canvasRef} style={{ display: "none" }} />
                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  sx={{ mt: 1 }}
                  onClick={takePhoto}
                >
                  Capturar Foto
                </Button>
              </Box>
            )}

            {photoPreview && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Box
                  sx={{
                    width: 180,
                    height: 180,
                    border: "2px solid #6b95c0",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={photoPreview}
                    alt="Foto tomada"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>
            )}

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                py: 1.5,
                fontWeight: "bold",
                background: "linear-gradient(45deg, #68a76b, #3e5a40)",
                "&:hover": {
                  background: "linear-gradient(45deg, #92be95, #0d3b14)",
                },
              }}
            >
              Crear Usuario
            </Button>
          </form>

          <Dialog open={dialogOpen} onClose={handleCloseDialog}>
            <DialogTitle>{errorMessage ? "Error" : "Éxito"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {errorMessage || dialogMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="primary">
                {success ? "Ir a lista de usuarios" : "Cerrar"}
              </Button>
            </DialogActions>
          </Dialog>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CrearUsuarios360;
